var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 15,
    viewBox: "0 0 28 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.540758 0.59394C0.316802 0.736458 0.143745 0.970593 0.0623066 1.22509C-0.13111 1.8257 0.0928461 2.23289 1.20245 3.22033C1.71144 3.67842 2.3324 4.26885 2.5869 4.53353C2.84139 4.7982 4.30729 6.14194 5.84444 7.50603C7.38159 8.8803 9.65169 10.9061 10.8834 12.0157C13.3571 14.2349 13.7745 14.5097 14.4158 14.3163C14.7925 14.1942 16.8895 12.4025 18.6201 10.7025C18.956 10.3666 20.4219 9.02282 21.8776 7.70963C23.3333 6.39643 24.7789 5.07306 25.0843 4.7473C25.3897 4.43173 26.0819 3.78022 26.6214 3.29159C27.7819 2.24307 28.0161 1.83588 27.8125 1.22509C27.5681 0.481962 26.7029 0.146029 25.9801 0.522682C25.6849 0.675379 21.5722 4.35029 21.501 4.52335C21.4806 4.56407 20.9004 5.12396 20.198 5.7551C19.4956 6.39643 18.6914 7.14974 18.4165 7.43477C17.8159 8.03538 14.2326 11.2726 14.0595 11.3744C13.9374 11.4354 8.47083 6.56949 6.50612 4.6455C4.94861 3.12871 2.23061 0.695738 1.89467 0.522682C1.44676 0.298726 0.94795 0.319086 0.540758 0.59394Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDropdown);
export default __webpack_public_path__ + "static/media/menu-dropdown.ade58e36486299767769251da3421db5.svg";
export { ForwardRef as ReactComponent };